const convertLang = lang => {
  return lang.replace('_', '-').replace(/(-)(\S)*/g, s => s?.toUpperCase())
}

export default {
  convertLang,
}
